import angular from 'angular';
import { MeurhSolicitacoesFaltasService } from './solicitacoesfaltas.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhSolicitacoesfaltasListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoesFaltasService',
                'ListagemService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhSolicitacoesFaltasService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_solicitacoesfaltas'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                            const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_solicitacoesfaltas'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('meurh_solicitacoesfaltas_not_found', $stateParams)) {
                                        $state.go('meurh_solicitacoesfaltas_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_solicitacoesfaltas', {
                url: '/solicitacoes/faltas?q',
                params: { q: { dynamic: true }, trabalhador: { tipo: '-1' } },
                template: require('html-loader!./index/solicitacoesfaltas.index.html'),
                controller: 'Meurh\SolicitacoesfaltasIndexController',
                controllerAs: 'mrh_slctcsflts_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesfaltas_funcionarios', {
                url: '/solicitacoes/faltas?q',
                params: { q: { dynamic: true }, trabalhador: { tipo: '0' } },
                template: require('html-loader!./index/solicitacoesfaltas.index.html'),
                controller: 'Meurh\SolicitacoesfaltasIndexController',
                controllerAs: 'mrh_slctcsflts_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesfaltas_contribuintes', {
                url: '/solicitacoes/faltas?q',
                params: { q: { dynamic: true }, trabalhador: { tipo: '1' } },
                template: require('html-loader!./index/solicitacoesfaltas.index.html'),
                controller: 'Meurh\SolicitacoesfaltasIndexController',
                controllerAs: 'mrh_slctcsflts_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesfaltas_estagiarios', {
                url: '/solicitacoes/faltas?q',
                params: { q: { dynamic: true }, trabalhador: { tipo: '2' } },
                template: require('html-loader!./index/solicitacoesfaltas.index.html'),
                controller: 'Meurh\SolicitacoesfaltasIndexController',
                controllerAs: 'mrh_slctcsflts_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesfaltas_new', {
                parent: 'meurh_solicitacoesfaltas',
                url: '/new?tipo',
                template: require('html-loader!./new/solicitacoesfaltas.new.html'),
                controller: 'MeurhSolicitacoesfaltasNewController',
                controllerAs: 'mrh_slctcsflts_frm_nw_cntrllr'
            })
            .state('meurh_solicitacoesfaltas_show', {
                parent: 'meurh_solicitacoesfaltas',
                url: '/:solicitacao?path',
                resolve,
                template: require('html-loader!./show/solicitacoesfaltas.show.html'),
                controller: 'MeurhSolicitacoesfaltasShowController',
                controllerAs: 'mrh_slctcsflts_frm_shw_cntrllr'
            })
            .state('meurh_solicitacoesfaltas_edit', {
                parent: 'meurh_solicitacoesfaltas',
                url: '/:solicitacao/edit',
                resolve,
                template: require('html-loader!./edit/solicitacoesfaltas.edit.html'),
                controller: 'MeurhSolicitacoesfaltasEditController',
                controllerAs: 'mrh_slctcsflts_frm_edit_cntrllr'
            });
    }
];
